module.exports = "/_next/static/images/d5f2feb6a819edadd42090fb7140db34-rec-group.svg";